/**
 * 验证手机号
 * @returns Boolean
 */
export function checkMobile(str) {
  var re = /^1\d{10}$/
  if (re.test(str)) {
    return true
  } else {
    return false
  }
}
/**
 * 验证邮箱
 * @returns Boolean
 */
function checkEmail(str) {
  var re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
  if (re.test(str)) {
    return true
  } else {
    return false
  }
}
/**
 * 验证密码
 * @returns Boolean
 */
function checkPwd(str) {
  if (str.length >= 6 && str.length <= 20) {
    return true
  } else {
    return false
  }
}
/**
 * 验证密码
 * @returns Boolean
 */
function ZZcheckPwd(str) {
  var pattern = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
  var result = str.match(pattern)
  if (result){
    return true
  }else{
    return false
  }
}
/**
 * 日期格式转换
 * @dateStr 日期字符串
 * @formatStr 格式 yyyy-mm-dd
 * @returns String
 */
function formatDate(dateStr, formatStr) {
  try{
    var date = new Date(dateStr.replace(/-/g, '/'))
  }catch(e){
    //TODO handle the exception
    var date = new Date(dateStr)
  }
  var str = formatStr;
  var Week = ['日', '一', '二', '三', '四', '五', '六']
  str = str.replace(/yyyy|YYYY/, date.getFullYear())
  str = str.replace(/MM/, (date.getMonth() + 1) > 9 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1))
  str = str.replace(/dd|DD/, date.getDate() > 9 ? date.getDate().toString() : '0' + date.getDate())
  return str
}
/**
 * 时间戳转换 多少时间前
 * @craetime 要转换的时间格式 2020-05-27 14:53:34
 * @nowtimes 当前时间 2020/05/27 15:46:03
 * @returns String 多少时间之前
 */
function formatMsgTime(craetime, nowtimes) {
  var c = new Date(nowtimes)
  nowtimes = c.getTime()
  var d = new Date(craetime.replace(/-/g, '/'))
  var create_time = d.getTime()
  var bettonTime = nowtimes - create_time
  bettonTime = parseInt(bettonTime / 60000)
  var x = ''
  if (bettonTime <= 0) {
    x = '刚刚'
  } else if (bettonTime > 1 && bettonTime <= 60) {
    x = bettonTime + '分钟前'
  } else if (bettonTime > 60 && bettonTime <= 1440) {
    bettonTime = parseInt(bettonTime / 60)
    x = bettonTime + '小时前'
  } else if (bettonTime > 1440 && bettonTime <= 41760) {
    bettonTime = parseInt(bettonTime / 1440)
    x = bettonTime + '天前'
  } else if (bettonTime > 41760 && bettonTime <= 501120) {
    bettonTime = parseInt(bettonTime / 41760)
    x = bettonTime + '月前'
  } else {
    x = '1年前'
  }
  return x
}

/**
 * 订单类型
 * @shijianchuo 2020-08-29T10:13:59.000+0000
 * @returns String 2020-05-27 14:53:34
 */
function add0(m){return m<10?'0'+m:m }
function format(shijianchuo) {
  //shijianchuo是整数，否则要parseInt转换
  var time = new Date(shijianchuo);
  var y = time.getFullYear();
  var m = time.getMonth()+1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
}
/**
 * 订单类型
 * @status 订单状态 toPay
 * @returns String
 */
function orderStatus(status, type) {
  var str = ''
  switch (status) {
    case 'toPay':
      str = '去支付'
      break;
    case 'invalid':
      str = '订单超时'
      break;
    case 'waitingDelivery':
      str = '待发货'
      break;
    case 'waitingApprise':
      str = '待评价'
      break;
    case 'waitingGoods':
      str = '待收货'
      break;
    case 'crowdfunding':
      str = '众筹中'
      break;
    case 'orderOver':
      str = '已完成'
      break;
    case 'refunded':
      if (type == 'crowdfunding'){
        str = '众筹失败'
      }else{
        str = '退款成功'
      }
      break;
		case 'waitingRefunded':
      if (type == 'crowdfunding'){
        str = '众筹失败'
      }else{
        str = '待退款'
      }
		  break;
    case 'closed':
      str = '交易关闭'
      break;
    case 'refunding':
      str = '退款中'
      break;
    default:
      str = ''
  }
  return str
}

/**
 * 时间字符串转换时间戳
 * @time 时间 2020-06-15 09:41:39
 * @returns timestamp 时间戳 1592185299000
 */

function timestamp(time){
  var nowTime = time.replace(/-/g, '/')
  var n = new Date(nowTime).getTime()
  return n
}

/**
 * 数量转换单位
 * @num 1000
 * @returns String 1k
 */

function numConven(num){
  num = Number(num)
  if (num >= 10000){
    num = Math.round(num / 1000) / 10  + 'W'
  }else if(num >= 1000){
    num = Math.round(num / 100) / 10  + 'K'
  }
  return num
}

/**
 * 获取东八区时间
 * @returns Number 1675143291263
 */
function targetDate() {
  var timezone = 8; //目标时区时间，东八区   东时区正数 西市区负数
  var offset_GMT = new Date().getTimezoneOffset(); // 本地时间和格林威治的时间差，单位为分钟
  var nowDate = new Date().getTime(); // 本地时间距 1970 年 1 月 1 日午夜（GMT 时间）之间的毫秒数
  var targetDate = new Date(nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000).getTime();
  return targetDate
}
/**
 * 根据给定的日期和当前日期的关系，以不同的格式展示时间
 * @date 时间 2020-06-15 09:41:39
 */

function formatDateTime(date){
  var nowTime = date.replace(/-/g, '/')
  const now = new Date();
  const inputDate = new Date(nowTime);
  // 获取年份、月份、日期、小时和分钟
  const inputYear = inputDate.getFullYear();
  const inputMonth = inputDate.getMonth() + 1;
  const inputDay = inputDate.getDate();
  const inputHours = inputDate.getHours()
  const inputMinutes = inputDate.getMinutes()

  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  const currentDay = now.getDate();

  // 判断是否为今天
  if (inputYear === currentYear && inputMonth === currentMonth && inputDay === currentDay) {
    return `${inputHours > 9 ? inputHours : '0'+inputHours}:${inputMinutes > 9 ? inputMinutes : '0'+inputMinutes}`;
  }
  // 判断是否为今年
  else if (inputYear === currentYear) {
    return `${inputMonth > 9 ? inputMonth : '0'+inputMonth}/${inputDay > 9 ? inputDay : '0'+inputDay}`;
  }
  // 非今年的情况
  else {
    return `${inputYear}/${inputMonth > 9 ? inputMonth : '0'+inputMonth}/${inputDay > 9 ? inputDay : '0'+inputDay}`;
  }
}


export default {
  checkMobile: checkMobile,
  checkEmail: checkEmail,
  checkPwd: checkPwd,
  formatDate: formatDate,
  formatMsgTime: formatMsgTime,
  orderStatus: orderStatus,
  timestamp: timestamp,
  numConven: numConven,
  ZZcheckPwd: ZZcheckPwd,
  format: format,
  targetDate: targetDate,
	formatDateTime: formatDateTime,
}
